/* ============================================================================
   Boho Accessory PDP — behaviour (multi-section)
   One controller wires the buy box together with the spec strip, benefits,
   fit-checker, FBT, accordion/FAQ and sticky bar. It uses document-wide queries
   + a single delegated click listener, so the content sections can be split
   into separate theme sections and reordered freely in the editor and still
   stay in sync. Re-runs on shopify:section:load. Reads config from the first
   inline [data-boho-pdp-config] JSON on the page. Boots once (__accPdpBooted).
   ============================================================================ */
(function () {
  "use strict";
  if (window.__accPdpBooted) return;
  window.__accPdpBooted = true;

  var $ = function (s) { return document.querySelector(s); };
  var $$ = function (s) { return Array.prototype.slice.call(document.querySelectorAll(s)); };

  // ---- config + state (module scope so they survive section reloads) ----
  var cfg = null, variants = [], optionNames = [], freeShip = 18000;
  var sizeOptionName = null, productName = "";
  var sel = {}, qty = 1, cartTotal = 0, firstAvail = null;
  var compOn = true, chosenTent = null;
  var stateReady = false, onceReady = false, io = null;

  var OKI = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12l5 5L20 6"/></svg>';
  var NOI = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M6 18 18 6M6 6l12 12"/></svg>';

  function money(pennies) {
    var p = (pennies || 0) / 100;
    var s = p.toLocaleString("en-GB", { minimumFractionDigits: p % 1 ? 2 : 0, maximumFractionDigits: 2 });
    return "£" + s;
  }
  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
    });
  }
  function currentVariant() {
    return variants.find(function (v) {
      return optionNames.every(function (n) { return v.options[n] === sel[n]; });
    }) || null;
  }

  function loadConfig() {
    var el = $('[data-boho-pdp-config]');
    if (!el) return false;
    try { cfg = JSON.parse(el.textContent); } catch (e) { return false; }
    variants = cfg.variants || [];
    optionNames = cfg.optionNames || [];
    freeShip = cfg.freeShipThreshold || 18000;
    sizeOptionName = cfg.sizeOptionName || null;
    productName = cfg.productName || "accessory";
    return true;
  }

  function initState() {
    firstAvail = variants.find(function (v) { return v.available; }) || variants[0] || null;
    optionNames.forEach(function (n) { sel[n] = firstAvail ? firstAvail.options[n] : null; });
    stateReady = true;
  }

  // ---- main render (queries fresh each call so it survives section reloads) ----
  function render() {
    var v = currentVariant();
    var price = v ? v.price : (firstAvail ? firstAvail.price : 0);

    $$('[data-pdp-price]').forEach(function (el) { el.textContent = money(price); });
    if (v) $$('[data-pdp-variant-id]').forEach(function (el) { el.value = v.id; });

    $$('[data-pdp-add]').forEach(function (addBtn) {
      if (v && v.available) { addBtn.disabled = false; addBtn.textContent = "Add to basket — " + money(price * qty); }
      else { addBtn.disabled = true; addBtn.textContent = v ? "Sold out" : "Unavailable"; }
    });

    $$('[data-pdp-stock-text]').forEach(function (stockText) {
      var dot = stockText.parentElement ? stockText.parentElement.querySelector('[data-pdp-stock-dot]') : null;
      if (v && v.available) {
        var low = v.inventory != null && v.inventory > 0 && v.inventory <= 10;
        stockText.textContent = low ? "Low stock — only " + v.inventory + " left" : "In stock, ready to ship";
        if (dot) dot.classList.toggle("low", low);
      } else {
        stockText.textContent = "Currently unavailable";
        if (dot) dot.classList.add("low");
      }
    });

    // free-ship progress — three states. The shortfall is based on what's
    // ACTUALLY in the basket (cartTotal), never assuming this item is added —
    // so an empty cart reads "Spend £180", not "Spend £81". Only when adding
    // this item would genuinely tip the basket over do we say "unlocks".
    var total = cartTotal + price * qty;
    var overNow = cartTotal >= freeShip;
    var tipsOver = !overNow && total >= freeShip;
    var fillPct = (overNow || tipsOver) ? 100 : Math.min(100, (cartTotal / freeShip) * 100);
    $$('[data-pdp-ship-fill]').forEach(function (f) { f.style.width = fillPct + "%"; });
    $$('[data-pdp-ship-msg]').forEach(function (msg) {
      if (overNow) {
        msg.innerHTML = "<span class=\"em\">You've unlocked free UK delivery</span>";
      } else if (tipsOver) {
        msg.innerHTML = "<span class=\"em\">Adding this to your basket unlocks free UK delivery</span>";
      } else {
        msg.innerHTML = "Spend <b>" + money(freeShip - cartTotal) + "</b> to get <span class=\"em\">free UK delivery</span>";
      }
    });

    // gallery: jump to this variant's image if it has one
    if (v && v.image) {
      $$('[data-pdp-gallery-main]').forEach(function (g) { g.style.backgroundImage = "url(" + v.image + ")"; g.setAttribute("data-current", v.image); });
      $$('[data-pdp-thumb]').forEach(function (t) { t.classList.toggle("active", t.getAttribute("data-img") === v.image); });
    }

    // disable option buttons with no available variant given the other picks
    $$('[data-opt-name]').forEach(function (btn) {
      if (!btn.classList.contains("pdp__opt")) return;
      var name = btn.getAttribute("data-opt-name");
      var val = btn.getAttribute("data-opt-val");
      var trial = Object.assign({}, sel); trial[name] = val;
      var ok = variants.some(function (vt) {
        return optionNames.every(function (n) { return vt.options[n] === trial[n]; }) && vt.available;
      });
      btn.disabled = !ok;
    });

    // sticky + label mirrors
    var label = optionNames.map(function (n) { return sel[n]; })
      .filter(function (x) { return x && x !== "Default Title"; }).join(" · ");
    $$('[data-sticky-price]').forEach(function (el) { el.textContent = money(price); });
    $$('[data-sticky-var]').forEach(function (el) { el.textContent = label; });

    fbtRender();
  }

  // ---- frequently bought together ----
  function fbtRender() {
    var fbt = $('[data-pdp-fbt]'); if (!fbt) return;
    var v = currentVariant();
    var base = v ? v.price : (firstAvail ? firstAvail.price : 0);
    var compPrice = parseInt(fbt.getAttribute("data-fbt-comp-price") || "0", 10);
    var total = base + (compOn ? compPrice : 0);
    var totalEl = fbt.querySelector('[data-fbt-total]');
    var compItem = fbt.querySelector('[data-fbt-comp-item]');
    if (totalEl) totalEl.innerHTML = money(total);
    if (compItem) compItem.classList.toggle("off", !compOn);
  }

  // ---- inline fit checker ("will it fit your tent?") ----
  function renderFit() {
    var fitRoot = $('[data-pdp-fit]'); if (!fitRoot) return;
    var fitResult = fitRoot.querySelector("[data-fit-result]"); if (!fitResult) return;
    if (!chosenTent) { fitResult.innerHTML = ""; return; }
    var universal = fitRoot.getAttribute("data-fit-universal") === "true";
    var fitSizeName = fitRoot.getAttribute("data-fit-sizename") || "";
    var fitSizes = (fitRoot.getAttribute("data-fit-sizes") || "").split(",").filter(Boolean);
    var nm = esc(fitRoot.getAttribute("data-fit-name") || "accessory");
    var t = esc(chosenTent), html;
    if (universal) {
      html = '<div class="fc-result ok">' + OKI + "<div><p>The <b>" + nm + "</b> fits any Boho bell tent door — including your <b>" + t + "</b>. You're good to go.</p></div></div>";
    } else if (fitSizes.indexOf(chosenTent) !== -1) {
      var isSel = sel[fitSizeName] === chosenTent;
      html = '<div class="fc-result ok">' + OKI + "<div><p>You need the <b>" + t + " " + nm + "</b> — made to fit " + t + " tents exactly.</p>" +
        (isSel ? '<span class="fc-result__set">' + OKI + " " + t + " is selected above</span>"
               : '<div class="fc-result__action"><button type="button" class="btn btn--primary" data-fit-pick="' + t + '">Select ' + t + " size →</button></div>") +
        "</div></div>";
    } else {
      html = '<div class="fc-result no">' + NOI + "<div><p>We don't make a <b>" + t + "</b> " + nm + " just yet. Message us and we'll help you find the right protection.</p></div></div>";
    }
    fitResult.innerHTML = html;
  }

  // ---- size modal helpers ----
  function coverSizes() {
    if (!sizeOptionName) return [];
    return variants.reduce(function (acc, v) {
      var sv = v.options[sizeOptionName]; if (sv && acc.indexOf(sv) < 0) acc.push(sv); return acc;
    }, []);
  }
  function openModal() { var m = $('[data-pdp-szmodal]'); if (m) m.hidden = false; }
  function closeModal() { var m = $('[data-pdp-szmodal]'); if (m) { m.hidden = true; var r = m.querySelector('[data-sz-result]'); if (r) r.innerHTML = ""; } }

  function pickOption(name, val) {
    sel[name] = val;
    $$('[data-opt-name="' + name + '"]').forEach(function (b) { b.classList.toggle("active", b.getAttribute("data-opt-val") === val); });
    var lab = $('[data-sel-label="' + name + '"]'); if (lab) lab.textContent = val;
    render();
  }

  // ---- cart: pull the live basket subtotal for the free-delivery bar ----
  function refreshCartTotal() {
    if (!window.fetch) return Promise.resolve();
    return fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { if (c && typeof c.total_price === "number") { cartTotal = c.total_price; render(); } })
      .catch(function () {});
  }

  // ---- add to cart, then open the THEME'S native cart drawer (unchanged).
  // The Concept <cart-drawer> listens on document for "cart:refresh": it re-
  // fetches its own section and opens when detail.open === true. We never touch
  // the drawer itself — we just fire the event the theme already uses. ----
  function addToCart(payload, errorFallback) {
    if (!window.fetch) { if (errorFallback) errorFallback(); return; }
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status) { if (errorFallback) errorFallback(); return; } // 422 etc.
        refreshCartTotal();
        document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true, detail: { open: true } }));
      })
      .catch(function () { if (errorFallback) errorFallback(); });
  }

  // ---- one delegated click listener (survives section reloads) ----
  document.addEventListener("click", function (e) {
    var t = e.target;

    var opt = t.closest && t.closest('[data-opt-name][data-opt-val]');
    if (opt) { pickOption(opt.getAttribute("data-opt-name"), opt.getAttribute("data-opt-val")); return; }

    var thumb = t.closest && t.closest('[data-pdp-thumb]');
    if (thumb) {
      var url = thumb.getAttribute("data-img");
      $$('[data-pdp-gallery-main]').forEach(function (g) { g.style.backgroundImage = "url(" + url + ")"; g.setAttribute("data-current", url); });
      $$('[data-pdp-thumb]').forEach(function (x) { x.classList.toggle("active", x === thumb); });
      return;
    }

    var q = t.closest && t.closest('[data-pdp-qty]');
    if (q) {
      qty = Math.max(1, qty + parseInt(q.getAttribute("data-pdp-qty"), 10));
      $$('[data-pdp-qty-val]').forEach(function (el) { el.textContent = qty; });
      $$('[data-pdp-qty-input]').forEach(function (el) { el.value = qty; });
      render();
      return;
    }

    var addT = t.closest && t.closest('[data-pdp-add-trigger]');
    if (addT) {
      e.preventDefault();
      var form = $('[data-pdp-form]');
      if (form && typeof form.requestSubmit === "function") form.requestSubmit();
      else if (form) form.submit();
      return;
    }

    var head = t.closest && t.closest('[data-accordion-head]');
    if (head && head.parentElement && head.parentElement.hasAttribute("data-accordion")) {
      var row = head.parentElement;
      var openNow = row.classList.contains("open");
      var group = head.getAttribute("data-accordion-head");
      if (group) $$('[data-accordion-group="' + group + '"]').forEach(function (r) { r.classList.remove("open"); });
      row.classList.toggle("open", !openNow);
      return;
    }

    if (t.closest && t.closest('[data-pdp-szopen]')) { openModal(); return; }
    if (t.closest && t.closest('[data-pdp-szclose]')) { closeModal(); return; }
    var modal = $('[data-pdp-szmodal]');
    if (modal && t === modal) { closeModal(); return; }

    var szt = t.closest && t.closest('[data-sz-tent]');
    if (szt && modal) {
      modal.querySelectorAll('[data-sz-tent]').forEach(function (x) { x.classList.toggle("active", x === szt); });
      var tent = szt.getAttribute("data-sz-tent");
      var box = modal.querySelector('[data-sz-result]');
      if (!box) return;
      if (coverSizes().indexOf(tent) >= 0) {
        box.className = "boho-pdp-szresult ok";
        box.innerHTML = OKI + '<div><p>Perfect — you need the <b>' + esc(tent) + ' ' + esc(productName) + '</b>. It\'s made to fit ' + esc(tent) + ' tents.</p>' +
          '<button class="btn btn--primary" data-sz-pick="' + esc(tent) + '">Select ' + esc(tent) + ' →</button></div>';
      } else {
        box.className = "boho-pdp-szresult no";
        box.innerHTML = NOI + '<div><p>We don\'t currently make this in <b>' + esc(tent) + '</b>. Message us and we\'ll help you find the right fit.</p></div>';
      }
      return;
    }
    var szp = t.closest && t.closest('[data-sz-pick]');
    if (szp && sizeOptionName) { pickOption(sizeOptionName, szp.getAttribute("data-sz-pick")); closeModal(); return; }

    var fo = t.closest && t.closest('[data-fit-opt]');
    if (fo) {
      var fitRoot = fo.closest('[data-pdp-fit]') || $('[data-pdp-fit]');
      chosenTent = fo.getAttribute("data-fit-opt");
      if (fitRoot) fitRoot.querySelectorAll('[data-fit-opt]').forEach(function (x) { x.classList.toggle("active", x === fo); });
      renderFit();
      return;
    }
    var fp = t.closest && t.closest('[data-fit-pick]');
    if (fp) {
      var fitRoot2 = $('[data-pdp-fit]');
      var fitSizeName = fitRoot2 ? (fitRoot2.getAttribute("data-fit-sizename") || "") : "";
      if (fitSizeName) pickOption(fitSizeName, fp.getAttribute("data-fit-pick"));
      renderFit();
      return;
    }

    if (t.closest && t.closest('[data-fbt-toggle]')) { compOn = !compOn; fbtRender(); return; }

    var fa = t.closest && t.closest('[data-fbt-add]');
    if (fa) {
      var fbt = $('[data-pdp-fbt]');
      var v = currentVariant(), items = [];
      if (v) items.push({ id: v.id, quantity: 1 });
      var compId = fbt ? fbt.getAttribute("data-fbt-comp-id") : null;
      if (compOn && compId) items.push({ id: parseInt(compId, 10), quantity: 1 });
      addToCart({ items: items }, function () { var form = $('[data-pdp-form]'); if (form) form.submit(); });
      return;
    }
  });

  // ---- intercept the buy-box form submit (and the sticky's requestSubmit) so
  // add-to-cart opens the native drawer instead of navigating to /cart. The
  // Shopify dynamic-checkout (Shop Pay) button is NOT a form submit, so it keeps
  // its own native flow untouched. ----
  document.addEventListener("submit", function (e) {
    var form = e.target.closest && e.target.closest('[data-pdp-form]');
    if (!form) return;
    e.preventDefault();
    var v = currentVariant();
    if (!v || !v.available) return;
    addToCart({ id: v.id, quantity: qty }, function () { form.submit(); });
  });

  // ---- one-time wiring: countdown, delivery date, sticky scroll, cart fetch ----
  // Dispatch day: today if it's a weekday before the 12pm cutoff, otherwise the
  // next working day (Mon-Fri). Delivery dates hang off THIS, not off "today" —
  // a Sunday view dispatches Monday, so "get it by" must be the dispatch day plus
  // transit, not today plus transit (which wrongly read Tuesday instead of Wed).
  function dispatchDay() {
    var d = new Date();
    var beforeCutoff = (d.getDay() !== 0 && d.getDay() !== 6) && d.getHours() < 12;
    if (!beforeCutoff) {
      do { d.setDate(d.getDate() + 1); } while (d.getDay() === 0 || d.getDay() === 6);
    }
    return d;
  }
  function tick() {
    var dispatchMsg = $('[data-pdp-dispatch-msg]');
    if (!dispatchMsg) return;
    var now = new Date();
    var disp = dispatchDay();
    var cutoff = new Date(disp); cutoff.setHours(12, 0, 0, 0);   // 12pm cutoff on the dispatch day
    var diff = Math.max(0, Math.floor((cutoff - now) / 1000));
    var h = Math.floor(diff / 3600), m = Math.floor((diff % 3600) / 60), s = diff % 60;
    var pad = function (n) { return String(n).padStart(2, "0"); };
    var clock = pad(h) + ":" + pad(m) + ":" + pad(s);
    var t0 = new Date(now); t0.setHours(0, 0, 0, 0);
    var d0 = new Date(disp); d0.setHours(0, 0, 0, 0);
    var days = Math.round((d0 - t0) / 86400000);
    var when = days <= 0 ? "dispatch today"
      : days === 1 ? "dispatch tomorrow"
        : "dispatch " + disp.toLocaleDateString("en-GB", { weekday: "long" });
    // countdown lives INSIDE the sentence so the order-by deadline is unambiguous
    dispatchMsg.innerHTML = 'Order within <b class="pdp-reassure__count" data-pdp-countdown>' + clock + '</b> for <b>' + when + '</b>';
  }

  function setupOnce() {
    if (onceReady) return; onceReady = true;

    tick(); setInterval(tick, 1000);

    var deliveryEl = $('[data-pdp-delivery]');
    if (deliveryEl) {
      // upper bound of the 1-2 day transit, measured from the dispatch day
      var d = dispatchDay(), added = 0;
      while (added < 2) { d.setDate(d.getDate() + 1); var dow = d.getDay(); if (dow !== 0 && dow !== 6) added++; }
      deliveryEl.textContent = d.toLocaleDateString("en-GB", { weekday: "short", day: "numeric", month: "short" });
    }

    var onScroll = function () {
      var sticky = $('[data-pdp-sticky]'), buyRef = $('[data-pdp-buyref]');
      if (!sticky || !buyRef) return;
      var r = buyRef.getBoundingClientRect();
      var nearBottom = window.innerHeight + window.scrollY > document.body.scrollHeight - 220;
      sticky.classList.toggle("show", r.bottom < 40 && !nearBottom);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();

    if ("IntersectionObserver" in window) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); } });
      }, { threshold: 0.08, rootMargin: "0px 0px -5% 0px" });
    }

    // live basket subtotal -> cart-aware free-delivery bar (fails silent)
    refreshCartTotal();

    // Keep the free-delivery bar LIVE: react to any cart change — our own add,
    // plus quantity/remove inside the theme's cart drawer. The Concept theme
    // publishes a cartUpdate pub/sub event on every cart change (payload.cart
    // has total_price); we also listen for the document cart:refresh event as a
    // fallback. Both just re-read the basket subtotal and re-render.
    try {
      if (window.theme && theme.pubsub && theme.pubsub.PUB_SUB_EVENTS && theme.pubsub.PUB_SUB_EVENTS.cartUpdate) {
        theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, function (payload) {
          var cart = payload && payload.cart;
          if (cart && typeof cart.total_price === "number") { cartTotal = cart.total_price; render(); }
          else refreshCartTotal();
        });
      }
    } catch (e) {}
    document.addEventListener("cart:refresh", function () { refreshCartTotal(); });
  }

  // ---- scroll reveal: visible by default, fade only while JS drives it ----
  function revealScan() {
    $$('[data-boho-pdp]').forEach(function (w) { if (w.querySelector("[data-reveal]")) w.classList.add("is-revealing"); });
    var fresh = $$('[data-reveal]').filter(function (el) { return !el.hasAttribute("data-reveal-seen"); });
    fresh.forEach(function (el) {
      el.setAttribute("data-reveal-seen", "1");
      var r = el.getBoundingClientRect();
      if (!io || r.top < window.innerHeight) el.classList.add("in");
      else io.observe(el);
    });
    setTimeout(function () { $$('[data-reveal]').forEach(function (el) { el.classList.add("in"); }); }, 1500);
  }

  // ---- boot (idempotent; re-runs on section load) ----
  function boot() {
    if (!loadConfig()) return;
    if (!stateReady) initState();
    setupOnce();
    render();
    fbtRender();
    renderFit();
    revealScan();
  }

  function safeBoot() {
    try { boot(); }
    catch (err) {
      $$('[data-boho-pdp]').forEach(function (w) {
        w.classList.remove("is-revealing");
        w.querySelectorAll("[data-reveal]").forEach(function (el) { el.classList.add("in"); });
      });
      if (window.console) console.error("[boho-pdp] init failed:", err);
    }
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", safeBoot);
  else safeBoot();
  document.addEventListener("shopify:section:load", function () { safeBoot(); });
})();
